import React from "react";
import contactUs from "../../PicesForPages/ContactUs.jpg";
import ContactForm from "../Form/ContactForm";

function ContactUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent ContactUsPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={contactUs}
          alt="contactUsImage"
          className="background-video contactUsImage"
        />
        <div className="purchasetopBox ContactUsPageTopBox">
          {/* The existing Purchase span */}
          <span>Contact Us</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox contactUsBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Get In Touch</span>
            <span className="purchaseBottomLeftContent contactUsBottomLeftContent">
              <span>Phone: </span>
              <span>(833) 745-6684 </span>
            </span>
            <a
              href="mailto: contact@primehomemtg.com"
              style={{ textDecoration: "none" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Email: </span>
              <span>contact@primehomemtg.com</span>
            </a>
            {/* <span className='purchaseBottomLeftContent contactUsBottomLeftContent'><span>Address: </span><span>1914 JN PEASE PL CHARLOTTE, NC 28262</span></span> */}
            <span className="purchaseBottomLeftContent contactUsBottomLeftContent">
              <span>Address: </span>
              <span>
                2120 Crown Centre Dr, Suite 400A, Charlotte, NC 28227.
              </span>
            </span>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
